























































































































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
// import { SwNav, SwNavGroup, SwNavItem, SwNavSectionDivider } from '@/shared/sw-nav';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwBadge } from '@libs-uuif/shared/sw-badge';
import { CoreStoreState, SetHelpContainerSlideVisiblePayload, SetSupportCasesSliderVisiblePayload } from '@/core';
import { RootStoreState } from '@/store';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { currentUserKey } from '../../shared/msw-constants';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { DropdownLight } from '../../shared/dropdown-light';
import { envCongif } from '@/shared/env.config';
import idb from '@/services/indexedDb.service';
import { PopoverDirValues } from '@sonicwall/unified-ui-framework/src/shared/popover-dir';
import { popover } from '@libs-uuif/shared/popover-dir';
import { CreateElement, VNode } from 'vue';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwButton } from '@libs-uuif/shared/sw-button';
import * as decode from 'jwt-decode';
import { MswGuestOrMswLoginRoute } from './../../modules/msw-guestlogin-accountlogin/index';
import { updateCartCountEventBus, UPDATE_CART_COUNT } from '../../modules/msw-checkout/constants/checkout-constants';
import _ from 'lodash';
import { updateNotificationCountEventBus, UPDATE_NOTIFICATION_COUNT } from './../../modules/msw-alert-slider';
import { localStorageKeeperService } from '@/shared/auth-service';

const cssPrefix = 'msw-app-header';
// const cssPrefix2 = 'chooseMswApps';
const activeColor = '#47afe8';
@Component({
  components: {
    // SwNavGroup,
    // SwNavItem,
    // SwNavSectionDivider,
    // SwNav,
    DropdownLight,
    SwIcon,
    SwBadge,
    SwMessageContainer,
    SwModal,
    SwModalBody,
    SwButton,
  },
  directives: {
    popover,
  },
})
export default class MswAppHeader extends SwExtendedVue {

  cssPrefix = cssPrefix;
  // cssPrefix2 = cssPrefix2;
  headerNameBadge: string = '';
  maintainenceMessage: string = '';
  activeColor = activeColor;
  flagstatus: any = '';
  showMSWApps: boolean = false;
  allApplicationList: any[] = [];
  showAppTrayBypClid: any = '';
  cartCount: number = 0;
  showLogoutPopup: boolean = false;
  notificationCounts: number = 0;
  @Prop({ type:Boolean })
  visiblehelp:boolean;
  @Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @Mutation
  readonly setSupportCaseSliderVisible: VuexMappedMutation<SetSupportCasesSliderVisiblePayload>;

  @Mutation
  readonly setAlertSliderVisible: VuexMappedMutation<SetSupportCasesSliderVisiblePayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.helpContainerSlideVisible)
  helpContainerSlideVisible: CoreStoreState['helpContainerSlideVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.alertSliderVisible)
  alertSliderVisible: CoreStoreState['alertSliderVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.supportCaseSliderVisible)
  supportCaseSliderVisible: CoreStoreState['supportCaseSliderVisible'];

  @State((state: RootStoreState) => state.CoreStoreModule.hideNavToggle)
  hideNavToggle: CoreStoreState['hideNavToggle'];

  @State((state:RootStoreState) => state.CoreStoreModule.selectedHelpId)
  selectedHelpId: CoreStoreState['selectedHelpId'];

  @State((state: RootStoreState) => state.CoreStoreModule.loggedIn)
  loggedIn: boolean;

  @State((state: RootStoreState) => state.CoreStoreModule.userInfo)
  userInfo: CoreStoreState['userInfo'];
  showUserProfileDropdown: boolean = false;
  profileorlogout: SelectOption[] = [];
  value: string = 'profile';
  environment: string = envCongif.env.includes('PROD') ? '' : envCongif.env;

  @State((state: RootStoreState) => state.CoreStoreModule.appVersionContent)
  appVersionContent: any;

  @Watch('appVersionContent')
  setMaintainenceMessage(res: any) {
    if (res.hasOwnProperty('maintText')) {
      if (res.maintText !== '') {
        this.maintainenceMessage = res.maintText;
      }
    }
  }

  get getCartCount() {
    return this.cartCount || 0;
  }

  setupCartCount() {
    this.cartCount = this.getCartCountFromLocalStorage();
    updateCartCountEventBus.$on(UPDATE_CART_COUNT, (value: any) => {
      this.cartCount = value || 0;
    });
  }

  setupNotifcationCount() {
    updateNotificationCountEventBus.$on(UPDATE_NOTIFICATION_COUNT, (res: any) => {
      this.notificationCounts = +(res) || 0;
    });
  }

  getCartCountFromLocalStorage() {
    let cartCount = 0;
    try {
      const rowCount = localStorage.getItem('cartCount') || '';
      cartCount = rowCount && JSON.parse(rowCount);
    } catch (e) {
      console.error(e);
    }
    return +cartCount || 0;
  }

  private onClickHelpContainerTrigger() {
    this.setHelpContainerSlideVisible({ visible: !this.helpContainerSlideVisible });
  }

  private onClickSupportCaseTrigger() {
    this.setSupportCaseSliderVisible({ visible: !this.supportCaseSliderVisible });
  }

  private onClickAlertsTrigger() {
    this.setAlertSliderVisible({ visible: !this.alertSliderVisible });
  }

  get clickPopoverValue(): PopoverDirValues {
    return {
      content: h => this.viewMSWAppsRender(h),
      noPadding: true,
      withCloseIcon: false,
      trigger: 'controlled',
      maxHeight: 336,
      maxWidth: 800,
      visible: this.showMSWApps,
      onClickOutsidePopper: () => { this.showMSWApps = false; },
    };
  }

  get isGuestBuyNow() {
    return this.$store.getters.isGuestBuyNowUser || false;
  }

  showMSWAppTray() {
    this.showMSWApps = !this.showMSWApps;
  }

  async logoutOpt() {
    if (this.getCartCount > 0) {
      this.showLogoutPopup = true;
    } else {
      this.logout();
    }
  }

  getNotificationCountFromApi() {
    const username = this.$store.getters.getUserId || '';
    this.$store.dispatch('getNotifyCount', username)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          updateNotificationCountEventBus.$emit(UPDATE_NOTIFICATION_COUNT, resp.content.notificationCount || '');
        }
      })
      .catch((errResponse : any) => {
        console.error(errResponse);
      });
  }

  async logout() {
    this.showLogoutPopup = false;
    const req = {
      clearCart: 'YES',
      allAPPS: this.value === 'logoutAll' ? 'YES' : 'NO',
    };
    await this.$store.dispatch('logout', req)
    .then((res:any) => {
      if (res.operationStatus === 'OK') {
        this.resetVueStore();
        localStorage.setItem(currentUserKey, '');
        localStorage.removeItem('supportCasesData');
        localStorage.removeItem('cartCount');
        this.$store.commit('mutate', { property: 'loggedIn', with: false });
        if (localStorageKeeperService.retrieve('showPendo') !== null) {
          localStorageKeeperService.cleanKey('showPendo');
        }
        idb.clearData()
        .then(() => {
          if (res.idplogoutUrl && res.idplogoutUrl !== '') {
            window.location.replace(res.idplogoutUrl);
            return;
          }
          if (this.showAppTrayBypClid === 'ACCOUNTSMSW312312') {
            // this.$router.push(`/m/login/login-view?accountLogOut=YES&mode=${this.value}`);
            if (this.value === 'logoutAll') {
              window.location.href = `${envCongif.accounts_url}/?logout=TRUE`;
            } else if (this.value === 'logout') {
              window.location.href = `${envCongif.accounts_url}/dashboard`;
            }
          } else {
            this.$router.push('/m/login/login-view');
          }
        });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
      }
    })
    .catch((err:any) => {
      console.error(err);
      this.$store.commit('enqueueMessage', {
        infoType: 'failed',
        infoMsg: this.$t('systemMessages.error')
        .toString(),
      });
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  resetVueStore() {
    this.$store.commit('startLoading');
    this.$store.dispatch('resetStore');
    this.$store.dispatch('DashBoardStoreModule/resetStore');
    this.$store.dispatch('MswProductsStoreModule/resetStore');
    this.$store.dispatch('DropdownStoreModule/resetStore');
  }

  onClickBasicButton() {
    switch (this.value){
      case 'profile':
        // window.location.href = 'https://10.202.8.44/muir/ui/profile';
        this.onClickDisplayName();
        break;
      case 'logout':
        this.logoutOpt();
        break;
      case 'logoutAll':
        this.logoutOpt();
        break;
    }
    // this.showUserProfileDropdown = !this.showUserProfileDropdown;
  }

  async created() {
    this.setupCartCount();
    if (!this.isGuestBuyNow && this.loggedIn) {
      this.setupNotifcationCount();
      this.getNotificationCountFromApi();
    }
    const tempObj: any = localStorage.getItem('currentUser') || {};
    const userInfoObtained: any = tempObj && !_.isEmpty(tempObj) && JSON.parse(tempObj);
    const splittedDisplayName = userInfoObtained.hasOwnProperty('displayName') ? userInfoObtained.displayName.split(' ') : [];
    this.headerNameBadge = `${splittedDisplayName.length > 0 ? splittedDisplayName[0].charAt(0) || '' : '' }${splittedDisplayName.length > 1 ?
    splittedDisplayName[1].charAt(0) || '' : '' }`;
    const displayName = userInfoObtained.hasOwnProperty('displayName') ? userInfoObtained.displayName : '';
    window.resizeTo(250, 250);

    this.profileorlogout.push({ id: 'profile', label: displayName, value: displayName });
    this.profileorlogout.push(
      {
        id: 'logout',
        label: this.$t('pilltooltip.logout')
        .toString(),
        value: 'Logout',
      },
    );
    const currentUserData = JSON.parse(localStorage.getItem('currentUser') || '');
    const decodedToken : any = decode(currentUserData.token);
    this.showAppTrayBypClid = decodedToken.pClid || '';
    this.$store.commit('mutate', { property: 'pCLid', with: decodedToken.pClid });
    if (this.showAppTrayBypClid === 'ACCOUNTSMSW312312' && !this.isGuestBuyNow) {
      this.profileorlogout.push(
        { id: 'logoutAll',
          label: this.$t('pilltooltip.logoutAll')
          .toString(),
          value: 'Logout All',
        },
      );
      await this.getApplications();
    }
    window.addEventListener('message', (e: any) => { if (e.data.isShowHelp) this.onClickHelpContainerTrigger(); }, false);
  }

  private onClickDisplayName() {
    const currentUserData = JSON.parse(localStorage.getItem('currentUser') || '');
    const decodedToken : any = decode(currentUserData.token);
    console.warn('is orgbased', decodedToken.orgbased);
    if (decodedToken.orgbased === 'YES') {
      this.$router.push('/m/feature/org-profile');
    } else {
      this.$router.push('/m/feature/profile');
    }
  }
  switchToClassic() {
    const sessionId = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const url = `${window.location.origin}/user/Homepage.aspx?I=${btoa(sessionId)}`;
    location.href = url;
  }
  navigateTo(path: string) {
    switch (path) {
      case 'alerts':
        this.$store.dispatch('navigateTo', 'ui/alerts');
        break;
      case 'manageCases':
        this.$store.dispatch('navigateTo', 'ui/managecases');
        break;
      case 'cart':
        this.goToCart();
        break;
    }
  }

  goToCart() {
    this.showLogoutPopup = false;
    const isaccountmswredirectRow: any = localStorage.getItem('isaccountsmswredirect');
    const isaccountsmswredirect: string = (isaccountmswredirectRow && JSON.parse(isaccountmswredirectRow)) || 'NO';
    if (this.isGuestBuyNow && isaccountsmswredirect === 'YES') {
      if (this.getCartCount === 0) {
        return;
      }
      this.$router.push({ path : `/m/${MswGuestOrMswLoginRoute.path}` });
    } else if (this.isGuestBuyNow && isaccountsmswredirect === 'NO') {
      if (this.getCartCount === 0) {
        return;
      }
      this.$router.push({ path: '/m/login/login-view', query: { loginmode: 'guestbuynow' } });
    } else {
      this.$router.push({ path : '/m/feature/cart' });
    }
  }

  private viewMSWAppsRender(h: CreateElement): VNode { // tslint:disable-line
    const allApplnList = this.allApplicationList.map((app:any) => {
      return <div class="chooseMswAppsCard" onClick={this.onClickApplications.bind(this, app)}>
        <img height="90" width="180" src={app.imageURL}/>
        <div class="chooseMswAppsCardTitle">
          { app.applicationName }
        </div>
      </div>;
    });
    return (
      <div class="chooseMswApps">
         { allApplnList }
      </div>
    ) as VNode;
  }

  async getApplications() {
    this.$store
      .dispatch('getApplications')
      .then((res: any) => {
        console.warn(res.content);
        this.allApplicationList = res.content.applicationList;
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  /* tslint:disable-next-line */
  onClickApplications(app: any) {
    this.showMSWApps = false;
    switch (app.applicationName) {
      case 'SandBox':
        this.handlerForSandbox(app.applicationName, app.launchUrl);
        break;
      case 'POSTIT':
        this.$store.dispatch('openURLInNextTab', `${envCongif.msw_url}${app.launchUrl.replace('~', '/muir')}`);
        break;
      case 'Capture Security Center':
        this.handlerForSpog(app.applicationName);
        break;
      case 'MySonicWall':
        this.handlerForMSW(app.applicationName);
        break;
      default:
        this.$store.dispatch('openURLInNextTab', app.launchUrl);
    }
  }

  async generateCodeFromToken(tileName: string) {
    let code = '';
    const requestForCodeGeneration: any = {
      tileName,
      tenantId: '',
    };
    await this.$store.dispatch('MswSupportCasesModule/getCSCScodeForWebChat', requestForCodeGeneration)
      .then((response: any) => {
        if (response?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
          this.$store.commit('resetToken');
          if (response?.content?.accessCode) {
            console.warn(response.content.accessCode);
            code = response?.content?.accessCode || '';
          }
        }
      })
      .catch((error) => {
        console.error('Cloud Tenants API error', error);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    console.warn(code);
    return code;
  }

  private async handlerForSandbox(tileName: string, launchUrl: string) {
    const sandboxAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${launchUrl}?CODE=${sandboxAccessCode}`);
  }

  private async handlerForSpog(tileName: string) {
    const cscAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${envCongif.spog_url}/muir/spog/login?CODE=${cscAccessCode}`);
  }

  private async handlerForMSW(tileName: string) {
    const mswAccessCode = await this.generateCodeFromToken(tileName);
    this.$store.dispatch('openURLInNextTab', `${envCongif.msw_url}/muir/login?CODE=${mswAccessCode}`);
  }
}
